import { ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable } from 'mobx';

import { UserModel } from '@/presentation/models/user.model';

@ViewModel()
export class LiveItemViewModel {
  constructor(private readonly userModel: UserModel) {
    makeObservable(this);
  }

  @action
  clearAccount() {
    return this.userModel.clearAccount();
  }

  @computed
  get user() {
    return this.userModel.user;
  }
}
